import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteSavedGrocery = async (id: number): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteSavedGrocery($id: Float!) {
        deleteSavedGrocery(id: $id)
      }
    `),
    variables: {
      id,
    },
  });

  return response.data?.deleteSavedGrocery ?? false;
};
